<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
</script>

<div class="{klass}">
	<FormWithLabel
		label="求人詳細"
		input={service.handleDetail}
		value={$model.detail}
		inputType="textarea"
	/>
</div>